import { useNavigate } from "react-router-dom";

import { ServiceForm } from "@/components/service/service-form";
import { OnboardingProgress } from "@/components/onboarding/onboarding-progress";
import { useUpdateUserSettingsMutation } from "@/hooks/use-user-settings";

export function OnboardingPage() {
  const navigate = useNavigate();
  const updateSettings = useUpdateUserSettingsMutation();

  const handleServiceCreated = () => {
    updateSettings.mutate({ onboarding_service: true });
    navigate("/onboarding/download");
  };

  return (
    <div className="space-y-8">
      <OnboardingProgress
        currentStep={1}
        title="Start by setting up your branding"
      />

      <ServiceForm mode="create" onSuccess={handleServiceCreated} hideHeader />
    </div>
  );
}
